import styled from 'styled-components'

export const Email = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const Phone = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: var(--space-350);
`

export const BannerWrapper = styled.div`
  margin-bottom: 32px;
`
